import type { User } from '@/configs/apis/user';
import type { Chat } from '@/contexts/chat/scripts/hooks/useChats/types';
import { getAvatar } from '@/scripts/utils/genAvatar';
import type { useChatContext } from '@/contexts/chat/context';
import Empty from '../empty';
import styles from './index.module.scss';

const Contacts = ({
  users,
  setOpen,
  activeChat,
  createChat,
}: {
  users: User[];
  setOpen: (open: boolean) => void;
  activeChat: (chatId: string) => void;
  createChat: ReturnType<typeof useChatContext>['createChat'];
  chats: Chat[];
}) => {
  return (
    <div className={styles.content}>
      {users.length === 0 && <Empty />}
      {users?.map((user) => {
        return (
          <div
            className={styles.userItem}
            key={user?.userId}
            onClick={async () => {
              setOpen(false);
              const chat = await createChat({ userId: user.userId });
              if (chat) {
                activeChat(chat.chat_id);
              }
            }}
          >
            <MyAvatar src={getAvatar(user.avatar, user.name)}></MyAvatar>
            <div className={styles.userInfo}>
              <div className={styles.name}>{user.name}</div>
              <div className={styles.username}>@{user.username}</div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default Contacts;
